import { CCSTORE } from './constants';
import { Price_Resp, CacheEntry } from './definitions';

export const calcCacheUpdate = (entry: CacheEntry) => ({
  type: CCSTORE.UPDATE_CALC_CACHE,
  entry,
});

export const clearCacheUpdate = () => ({
  type: CCSTORE.CLEAR_CACHE,
});
